import { render } from "./IncomeExpenditure.vue?vue&type=template&id=7d607358&scoped=true"
import script from "./IncomeExpenditure.vue?vue&type=script&lang=js"
export * from "./IncomeExpenditure.vue?vue&type=script&lang=js"

import "./IncomeExpenditure.vue?vue&type=style&index=0&id=7d607358&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d607358"]])

export default __exports__